import { GeneralSection } from "./GeneralSection";
import { Column, ErrorPlaceholder } from "@/components";

import { cn } from "@/lib/utils";
import { CompanyInternalConfig as CompanyInternalConfigType } from "@/types";

export const CompanyInternalConfig = ({
  className,
  companyInternalConfig,
}: {
  className?: string;
  companyInternalConfig?: CompanyInternalConfigType;
}) => {
  /* Render */
  const render = () => {
    if (!companyInternalConfig) {
      return (
        <ErrorPlaceholder errorMessage="Company Internal Config not found" />
      );
    }

    return (
      <div className="min-h-screen bg-slate-50">
        <Column
          className={cn("mx-auto w-full max-w-3xl gap-6 py-6", className)}
        >
          <GeneralSection companyInternalConfig={companyInternalConfig} />
        </Column>
      </div>
    );
  };

  return render();
};
